import { plainToInstance } from 'class-transformer';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo, useState } from 'react';
import { PromotionService } from '~/service/service.promotion';
import { UIService } from '~/service/service.ui';
import { PromotionNewbieDto } from '~/shared/dto/admin/promotion.dto';
import { Form } from '~/shared/form';
import { useService } from '~/shared/service/service.base';
import { PromotionNewbieDialog } from '../dialog/dialog.promotion.fragrance';
import { PromotionDraggableList } from './promotion.list';

export type PromotionNewbiesProps = {
	field: Form.Field<PromotionNewbieDto[]>;
};

export const PromotionNewbies = observer(({ field }: PromotionNewbiesProps) => {
	const [ui, promotion] = useService(UIService, PromotionService);
	const [initial, setInitial] = useState<PromotionNewbieDto | undefined>(undefined);

	const handleApply = useCallback(
		(newbie: PromotionNewbieDto) => {
			const arr = Array.from(field.value || []);
			const index = arr.findIndex(o => o.fragranceId === newbie.fragranceId);
			if (index >= 0) arr[index] = newbie;
			else {
				newbie.order = arr.length + 1;
				arr.push(newbie);
			}
			field.set(arr);
		},
		[field],
	);

	const hadnleAdd = useMemo(() => {
		return (newbie?: PromotionNewbieDto) => {
			setInitial(newbie || plainToInstance(PromotionNewbieDto, { order: 1 }));
			ui.showDialog(PromotionNewbieDialog);
		};
	}, [ui]);

	const handleDelete = useCallback(
		(newbie: PromotionNewbieDto) => {
			const arr = field.value?.filter(b => b.fragranceId !== newbie.fragranceId) || [];
			arr.forEach((item, idx) => (item.order = idx + 1));
			field.set(arr);
		},
		[field],
	);

	const fragrances = promotion.fragrances.map(f => ({
		...f,
		active: f.active && !field.value?.some(o => o.fragranceId === f.id),
	}));

	return (
		<>
			<PromotionDraggableList label="New arrivals" field={field} onAdd={hadnleAdd} onDelete={handleDelete} />
			<PromotionNewbieDialog fragrances={fragrances} initial={initial} onApply={handleApply} />
		</>
	);
});
